/**
 * Отрезает последний сегмент пути поля: `a.b[0].c` -> `a.b[0]` -> `a.b` -> `a` -> ''.
 * Используется и для имён полей формы, и для id блоков в разметке - они строятся
 * по одной схеме (см. fieldsElementsIds).
 */
export const getParentFlatName = (flatName: string): string => {
  const cutIndex = Math.max(flatName.lastIndexOf('.'), flatName.lastIndexOf('['));

  return cutIndex <= 0 ? '' : flatName.slice(0, cutIndex);
};
